module.exports = __webpack_public_path__ + "static/media/manu.5a31550f.jpg";